module.exports = __webpack_public_path__ + "img/norrtag-special-kreditering.9990f0be.png";